import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import Toolbar from '../components/common/Toolbar';
import SearchBar from '../components/common/SearchBar';
import FederationCard from '../components/common/FederationCard';

const regionalFeds = [
  { name: 'GD Lazio', territory: 'Lazio', description: "Il coordinamento regionale dei Giovani Democratici del Lazio.", circles: 120, members: '2400+', type: 'regionale', image: '/assets/images/regions/lazio.png' },
  { name: 'GD Lombardia', territory: 'Lombardia', description: "Il coordinamento regionale dei Giovani Democratici della Lombardia.", circles: 150, members: '3000+', type: 'regionale', image: '/assets/images/regions/lombardia.png' },
  { name: 'GD Toscana', territory: 'Toscana', description: "Il coordinamento regionale dei Giovani Democratici della Toscana.", circles: 90, members: '1800+', type: 'regionale', image: '/assets/images/regions/toscana.png' },
  { name: 'GD Emilia-Romagna', territory: 'Emilia-Romagna', description: "Il coordinamento regionale dei Giovani Democratici dell'Emilia-Romagna.", circles: 110, members: '2200+', type: 'regionale', image: '/assets/images/regions/emilia-romagna.png' },
  { name: 'GD Campania', territory: 'Campania', description: "Il coordinamento regionale dei Giovani Democratici della Campania.", circles: 85, members: '1600+', type: 'regionale', image: '/assets/images/regions/campania.png' },
];

const FederazioniRegionaliPage = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredFeds = regionalFeds.filter(f =>
    f.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    f.territory.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Federazioni Regionali' }];

  return (
    <Layout>
      <HeroPage
        breadcrumbs={breadcrumbs}
        overline="Territorio"
        title="Federazioni Regionali"
        subtitle="I 20 coordinamenti regionali dei Giovani Democratici indirizzano l'azione politica e coordinano il lavoro delle federazioni provinciali."
      />

      <section className="section section--sm">
        <div className="container">
          <Toolbar className="mb-6"
            left={<SearchBar placeholder="Cerca coordinamento..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />}
          />

          <div className="results-count mb-6">
            Trovate <strong>{filteredFeds.length}</strong> federazioni regionali
          </div>

          <div className="grid grid-3">
            {filteredFeds.map((f) => (
              <FederationCard key={f.name} {...f} />
            ))}
          </div>

          {filteredFeds.length === 0 && (
            <div className="text-center py-20">
              <p className="text-secondary">Nessun coordinamento trovato con questi criteri.</p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
};

export default FederazioniRegionaliPage;
